import * as React from "react";
import { Input, Table, Header, Divider, Segment, Message } from "semantic-ui-react";
import 'katex/dist/katex.min.css';

import UGammaDist from '../../../components/util/UGammaDist';

const { jStat } = require('jstat');
const { InlineMath, BlockMath } = require('react-katex')


interface INbdProps {
  state: any;
}

interface INbdState {
  alpha: number;
  beta: number;
}


class Gamma extends React.Component<INbdProps, INbdState> {

  constructor(props: INbdProps) {
    super(props);
    this.state = {
      alpha: 3,
      beta: 2,
    };

    this.alpha_handleInput = this.alpha_handleInput.bind(this);
    this.beta_handleInput = this.beta_handleInput.bind(this);

  }

  alpha_handleInput(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();
    this.setState({
      alpha: Number(event.currentTarget.value),
    })
  }

  beta_handleInput(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();
    this.setState({
      beta: Number(event.currentTarget.value),
    })
  }


  render() {
    return (
      <div>
        <Header as="h3">ガンマ分布</Header>
        <Divider />
        ガンマ分布は<a href="https://ja.wayama.io/article/mkt/1/#heading-3">こちら</a>より、以下の様に表現できます。
        <BlockMath>{`f\\left(x|\\alpha, \\beta \\right) =\\frac{x ^ {\\alpha - 1}e^{-\\frac{x}{\\beta}}}{\\Gamma\\left(\\alpha \\right)\\beta^{\\alpha}} `}</BlockMath>

        <h4>パラメタの設定</h4>

        <div className="nbd_model_selected">
          <Table celled>
            <Table.Header className='model_table_header'>
              <Table.Row>
                <Table.HeaderCell>項目</Table.HeaderCell>
                <Table.HeaderCell>値</Table.HeaderCell>
                <Table.HeaderCell>入力<br />check</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body className='model_tabe_body'>
              <Table.Row>
                <Table.Cell><InlineMath>{`\\alpha`}</InlineMath></Table.Cell>
                <Table.Cell>
                  <Input
                    placeholder='3'
                    onChange={this.alpha_handleInput}
                  />
                </Table.Cell>
                <Table.Cell>
                  {this.state.alpha}
                </Table.Cell>

              </Table.Row>

              <Table.Row>
                <Table.Cell><InlineMath>{`\\beta`}</InlineMath></Table.Cell>
                <Table.Cell>
                  <Input
                    placeholder='2'
                    onChange={this.beta_handleInput}
                  />
                </Table.Cell>
                <Table.Cell>
                  {this.state.beta}
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>
        </div>

        <UGammaDist
          data={{
            alpha: this.state.alpha,
            beta: this.state.beta,
          }}
        />

      </div>
    );
  };

}
export default Gamma;
